import { atob as decode, btoa as encode } from '~/ui/vue/filters'

export const encodeParam = param => param ? encode(JSON.stringify(param)) : param

export const decodeParam = param => param ? JSON.parse(decode(param)) : param

/**
 * Generates a mixin that links URL query params with specified prop and data source
 * @param {string} propName - Property name that will contain URL query param content
 * @param {object} source - Source where propName is contained
 * @returns {Object} A Vue mixin
 */
export default (propName, source) => ({
  computed: {
    _linkable_linkHash () {
      const data = (source || this)[propName]
      if (!Object.keys(data || {}).length) return
      return encodeParam(data)
    }
  },
  watch: {
    _linkable_linkHash: {
      handler (newHash, oldHash) {
        if (newHash === oldHash || newHash === this.$route.query.q) return

        // make sure we preserve any other query params
        const params = new URLSearchParams(this.$route.query)
        if (this._linkable_linkHash) {
          params.set('q', this._linkable_linkHash)
        } else {
          params.delete('q')
        }
        // update URL without adding to history
        this.$router.replace({ query: Object.fromEntries(params) })
      },
      immediate: true
    }
  },

  methods: {
    /**
    * @todo(vue3-migration): Navigation guards in mixins are ignored now with Vue Router 4,
    * so review the beforeRouteUpdate and beforeRouteEnter after verifying all pages using this mixin
    * Reference: https://router.vuejs.org/guide/migration/#Navigation-guards-in-mixins-are-ignored
    */
    beforeRouteEnterCallback (to, from, next) {
      if (!to.query.q) return
      this.linkable_loadParam(to.query.q)
      next()
    },
    beforeRouteUpdateCallback (to, from, next) {
      // Prevents the q param from getting dropped if linkHash has a value and user is navigating to the same route
      if (this._linkable_linkHash && !to.query.q) return
      next()
    },
    linkable_loadParam (param) {
      try {
        (source || this)[propName] = decodeParam(param)
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') console.error(e)
      }
    }
  }
})
